// src/cal.js
// Single place for all Cal.com embed logic. Idempotent: safe under React StrictMode / re-renders.

export const CAL_LINK = 'awpressurewash/residentialestimate';
export const CAL_ORIGIN = 'https://app.cal.com';
export const CAL_NS_INLINE = 'residentialestimate';
export const CAL_NS_POPUP = 'estimatePopup';

let loaderInstalled = false;
let floatingMounted = false;
const initializedNamespaces = new Set();

// Cal.com's official loader snippet, un-minified. Queues commands until embed.js loads.
function installLoader() {
  if (loaderInstalled || typeof window === 'undefined') return;
  loaderInstalled = true;

  (function (C, A, L) {
    const p = function (a, ar) {
      a.q.push(ar);
    };
    const d = C.document;
    C.Cal =
      C.Cal ||
      function () {
        const cal = C.Cal;
        const ar = arguments;
        if (!cal.loaded) {
          cal.ns = {};
          cal.q = cal.q || [];
          d.head.appendChild(d.createElement('script')).src = A;
          cal.loaded = true;
        }
        if (ar[0] === L) {
          const api = function () {
            p(api, arguments);
          };
          const namespace = ar[1];
          api.q = api.q || [];
          if (typeof namespace === 'string') {
            cal.ns[namespace] = cal.ns[namespace] || api;
            p(cal.ns[namespace], ar);
            p(cal, ['initNamespace', namespace]);
          } else {
            p(cal, ar);
          }
          return;
        }
        p(cal, ar);
      };
  })(window, `${CAL_ORIGIN}/embed/embed.js`, 'init');
}

function getCalNamespace(namespace) {
  if (typeof window === 'undefined') return null;
  installLoader();

  if (!initializedNamespaces.has(namespace)) {
    window.Cal('init', namespace, { origin: CAL_ORIGIN });
    initializedNamespaces.add(namespace);
  }
  window.Cal.config = window.Cal.config || {};
  window.Cal.config.forwardQueryParams = true;

  return window.Cal.ns[namespace];
}

// Inline month-view booker rendered into the element matching `selector`.
export function mountInlineEmbed(selector) {
  const cal = getCalNamespace(CAL_NS_INLINE);
  if (!cal) return;

  cal('inline', {
    elementOrSelector: selector,
    config: { layout: 'month_view', useSlotsViewOnSmallScreen: 'true', theme: 'auto' },
    calLink: CAL_LINK,
  });

  cal('ui', {
    cssVarsPerTheme: { dark: { 'cal-brand': '#e70000' } },
    hideEventTypeDetails: true,
    layout: 'month_view',
  });
}

// Floating popup button (replaces the Free Estimate buttons). Mounts once per page load.
export function mountFloatingButton() {
  if (floatingMounted) return;
  const cal = getCalNamespace(CAL_NS_POPUP);
  if (!cal) return;
  floatingMounted = true;

  cal('floatingButton', {
    calLink: CAL_LINK,
    buttonText: 'Free Estimate', // Cal's default is "Book my Cal"
    buttonColor: '#16a34a', // matches the site's green-600 CTAs
    buttonTextColor: '#ffffff',
    config: { layout: 'month_view', useSlotsViewOnSmallScreen: 'true' },
  });

  cal('ui', { hideEventTypeDetails: false, layout: 'month_view' });
}
